import axios, { AxiosInstance, AxiosError } from 'axios';

export interface ApiErrorPayload {
    status_code: number;
    message: string;
    body?: object;
    errors?: Array<string>;
}

interface CustomAxiosError extends AxiosError {
    response: AxiosError['response'] & {
        data: ApiErrorPayload;
    };
}

class CustomError extends Error {
    public status: number;
    public errors?: string[];
    public url?: string;

    constructor(status: number, message: string, errors?: Array<string>, url?: string) {
        super(message);
        this.status = status;
        this.errors = errors;
        this.url = url;
    }
}

export class AxiosHttp {
    private instance: AxiosInstance;

    constructor(baseUrl: string | undefined, headers: object = {}) {
        this.instance = axios.create({
            baseURL: baseUrl,
            headers,
            timeout: 30000,
        });
    }

    async get<T>(url: string): Promise<T> {
        try {
            const response = await this.instance.get<T>(url);
            return response.data;
        } catch (err) {
            this.handleError(err, 'GET', url);
        }
    }

    async post<T>(url: string, body: object): Promise<T> {
        try {
            const response = await this.instance.post<T>(url, body);
            return response.data;
        } catch (err) {
            this.handleError(err, 'POST', url);
        }
    }

    private handleError(err: unknown, method: string, url?: string): never {
        if (axios.isAxiosError(err)) {
            const axiosErr = err as CustomAxiosError;

            const status = axiosErr.response?.status;
            const message = axiosErr.response?.data?.message || axiosErr.message;
            const errors = axiosErr.response?.data?.errors;

            throw new CustomError(status, message, errors, url);
        }

        throw new Error(`[Axios ${method}] Erro inesperado: ${String(err)}`);
    }
}
